import axios from "axios";
import { toast } from "react-toastify";

let is403Error = false;

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_HOSPITAL_BASEURL,
  headers: {
    "Content-type": "application/json",
  },
});

const navigateToLogin = () => {
  localStorage.clear();
  globalThis.location.href = "/";
};

axiosInstance.interceptors.request.use(
  (config) => {
    const sToken = localStorage.getItem("access_token");
    if (!config.headers["Authorization"]) {
      config.headers["Authorization"] = `Bearer ${sToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 403) {
      if (!is403Error) {
        is403Error = true;
        toast.warn("Your session has ended. Please log in again to continue.");
        navigateToLogin();
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;